import { useEffect, useState } from "react";
import { DidYouMeanState, QuerySummary as HeadlessQuerySummary } from "@coveo/headless";
import { CoveoHeadlessData, PageType } from "components/coveo-headless/types/coveo-headless-types";

type PublicSearchTotalResultsProps = {
	controller: HeadlessQuerySummary;
	pageType: string;
	resultDescription: string;
	showInFilters: boolean;
	coveoDidYouMean: CoveoHeadlessData["didYouMean"] & {
		applyCorrection: () => void;
		coveoSuggestionsState?: DidYouMeanState;
	};
};

const PublicSearchTotalResults = ({
	controller,
	pageType,
	resultDescription,
	showInFilters,
	coveoDidYouMean
}: PublicSearchTotalResultsProps) => {
	const [state, setState] = useState(controller.state);
	useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

	const { total, hasQuery, query } = state;

	return (
		<>
			{pageType === PageType.Search && !showInFilters && (
				<div className="public-search-page-header-results-text">
					<h2 className="t-heading-xl">
						<span className="t-heading-xl query-total">{total}</span>
						{hasQuery ? (
							<>
								<span>{` ${resultDescription} `}</span>
								<span className="t-heading-xl query-text">{query}</span>
							</>
						) : (
							""
						)}
					</h2>
					{coveoDidYouMean.coveoSuggestionsState?.hasQueryCorrection ? (
						<div className="public-search-page-header-results-text-suggestions t-body-xxs-italic tc-cool-gray-01">
							{coveoDidYouMean.coveoSuggestionsState.wasAutomaticallyCorrected ? (
								<>
									<p>
										{`${coveoDidYouMean.noResultsText} `}
										{coveoDidYouMean.coveoSuggestionsState.originalQuery}
									</p>
									<p>
										{`${coveoDidYouMean.correctedText} `}
										{coveoDidYouMean.coveoSuggestionsState.queryCorrection.correctedQuery}
									</p>
								</>
							) : (
								<p>
									{`${coveoDidYouMean.suggestionsText} `}
									<button
										className="public-search-page-header-results-text-suggestions-link t-body-xxs-heavy"
										onClick={() => coveoDidYouMean.applyCorrection()}
									>
										{coveoDidYouMean.coveoSuggestionsState.queryCorrection.correctedQuery}
									</button>
								</p>
							)}
						</div>
					) : null}
				</div>
			)}
		</>
	);
};

export default PublicSearchTotalResults;
